export const PLAY = "PLAY";
export const STOP = "STOP";

export const play = () => ({
  type: PLAY,
});

export const stop = () => ({
  type: STOP,
});
